import { IonFab, IonFabButton, useIonModal } from "@ionic/react";
import { CreateNewLeagueProvider } from "./context/index.js";
import { Md2Plus } from "react-icons-ng/md2";
import React, { Suspense } from "react";

const NewLeagueModal = React.lazy(() => import("./modal/index.js"));

const CreateNewLeague = () => {
  return (
    <>
      <IonFab
        slot="fixed"
        vertical="bottom"
        horizontal="end"
        id="open-createNewLeagueModal"
      >
        <IonFabButton>
          <Md2Plus className="h-6 w-6" />
        </IonFabButton>
      </IonFab>
      <Suspense fallback={<div>Loading...</div>}>
        <CreateNewLeagueProvider>
          <NewLeagueModal />
        </CreateNewLeagueProvider>
      </Suspense>
    </>
  );
};

export default CreateNewLeague;
